import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress'

export const Progress = (props: CircularProgressProps) => {
  return <CircularProgress {...props} />
}
